<template>
	<div>
		<div class="row" id="bilan_comptable" >
			<div class="row">
				<form >
					<div class="form-group  group-2-col">
						<label>Date de début</label>
						<input-date v-model="startDate" class="form-control datepicker" required></input-date>
					</div>
					<div class="form-group  group-2-col">
						<label>Date de fin</label>
						<input-date v-model="endDate" class="form-control datepicker" required></input-date>
					</div>
					<div class="form-group col-md-12">
						<button v-on:click="getInfo" class="btn btn-primary">Calculer</button>
						<button type="button" class="btn btn-primary" :disabled="!bilanDisplayed" data-toggle="modal"
										data-target="#confirm_export_modal" @click="setAction('factures')">Factures</button>
						<button type="button" class="btn btn-primary" :disabled="!bilanDisplayed" data-toggle="modal"
										data-target="#confirm_export_modal" @click="setAction('facturesPresta')">Factures Presta</button>
						<button v-on:click="getProExps" class="btn btn-primary" :disabled="!bilanDisplayed">Frais Pro</button>
					</div>
				</form>
			</div>
			<bilan-data v-if="!isEntreprise" :info="bilanData" ref="bilanComponent"></bilan-data>
			<div v-else class="col-md-7 col-md-offset-1">
				<bilan-data-entreprise :info="bilanData" :show-by-default="false" :counter-up="false" ref="bilanComponent"></bilan-data-entreprise>
			</div>
		</div>
		<div class="row">
			<div class="col-md-6 col-xs-12 col-sm-12" id="customerChart" hidden>
				<canvas id="graphCustomers"></canvas>
			</div>
			<div class="col-md-6 col-xs-12 col-sm-12" id="honoraireChart" hidden>
				<canvas id="graphHonoraire"></canvas>
			</div>
		</div>
		<!--confirm billing export-->
		<div id="confirm_export_modal" class="modal fade" role="dialog">
			<div class="modal-dialog" role="document">
				<form @submit.prevent="addBillingPayment" class="modal-content row">
					<div class="modal-header row col-md-10 col-md-offset-1">
						<button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
						<h3 class="modal-title font-blue col-md-10 col-md-offset-1">Extraction de facture</h3>
					</div>
					<div class="modal-body col-md-10 col-md-offset-1">
						<div class="row">
							<p>Suivant la quantité de factures, cela peut être très long à charger. Vous pouvez continuer à naviguer sur l'application en attendant.</p>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Annuler</button>
						<button type="button" class="btn btn-primary" data-dismiss="modal" v-on:click="getBillings">Ok</button>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>


<script>
  import { usefulMethodsMixin } from '../mixins/useful-methods-mixin'
	export default {
		name: 'bilan',
		mixins : [usefulMethodsMixin],
		props: {
			office : Object,
			isEntreprise:Boolean
		},
		data () {
			return {
				startDate: "",
				endDate: "",
				errors: [],
				bilanData:{},
				bilanDisplayed:false,
				actionType: '',
			}
		},
		methods: {
			getInfo: function(event)
			{
				event.preventDefault()
				this.errors=[]
				if(this.startDate=="" || this.endDate==""){
					this.errors.push('Les champs "Date de début" et "Date de fin" doivent être remplis')
				}
				if(this.errors.length){
					return false;
				}
				$("#errrorsContainer").hide()
				axios.get('/billing/getbilan/'+this.formatDateForDatabase(this.startDate)+"/"+this.formatDateForDatabase(this.endDate))
				.then(response => {
					this.bilanData=response.data
					this.$refs.bilanComponent.show()
					this.bilanDisplayed=true
            })
				.catch(error => {
					console.log(error)
				});
			},
			setAction: function(action){
				this.actionType = action;
			},
			getBillings: function(event){
				event.preventDefault()
				this.errors=[]
				if(this.startDate=="" || this.endDate==""){
					this.errors.push('Les champs "Date de début" et "Date de fin" doivent être remplis')
				}
				if(this.errors.length){
					return false;
				}
				let url = (this.actionType === 'factures') ? 'getbillings/' : 'getbillingspresta/';
				window.open(url +this.formatDateForDatabase(this.startDate)+"/"+this.formatDateForDatabase(this.endDate), "_blank");
			},
			getProExps: function(event){
				event.preventDefault()
				this.errors=[]
				if(this.startDate=="" || this.endDate==""){
					this.errors.push('Les champs "Date de début" et "Date de fin" doivent être remplis')
				}
				if(this.errors.length){
					return false;
				}
				window.open('../professionalexpense/getexpenses/'+this.formatDateForDatabase(this.startDate)+"/"+this.formatDateForDatabase(this.endDate), "_blank");
			},
			formatDate: function(inputDate,sep="/")
			{
				let date;
				if (Object.prototype.toString.call(inputDate) !== "[object Date]"){
					date = new Date(inputDate)
				}else{date=inputDate}
				if (isNaN(date.getTime())){
					console.error('"'+inputDate+'" cannot be formated to a Date object')
					return false
				}
				let dd = date.getDate()
         let mm = date.getMonth() + 1; //January is 0!
         let yyyy = date.getFullYear()
         if (dd < 10) {
         	dd = '0' + dd
         }
         if (mm < 10) {
         	mm = '0' + mm
         }
         return [yyyy,mm,dd].join(sep)
       }
     }
   }

 </script>

<style lang="css" scoped>
.number{
	font-size: 14px !important;
	height: inherit;
	font-weight: bold;
}
.modal-open .datepicker{
	z-index:auto !important;
}
</style>
